/* Recomendados: se piden por Section Rendering API y se revelan al entrar. */
const { mount, reveal } = window.EQ;
mount('[data-eq-recs]', (root) => {
  let rev = null;
  const url = root.dataset.url;
  const pintar = async () => {
    if (root.querySelector('.eq-recs__in')) { rev = reveal(root); return; }
    if (!url) return;
    try {
      const r = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!r.ok) return;
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const inner = doc.querySelector('[data-eq-recs]');
      if (!inner || !inner.querySelector('.eq-recs__in')) return;
      root.innerHTML = inner.innerHTML;
      rev = reveal(root);
    } catch (e) { /* sin recomendados: la seccion queda vacia */ }
  };
  pintar();
  return () => { if (rev) rev.destroy(); };
});
